import { createColumnHelper } from '@tanstack/react-table'
import { getConsolidateInvoiceDescription } from '../../../../../../utils/getConsolidateInvoiceDescription'
import type { Fuel } from '../../../../../../types'
import { NavLink } from 'react-router-dom'
import { formatCurrency } from '../../../utils/formatCurrency'
import { formatNumber } from '../../../utils/formatNumber'

const settings = {
  digits: {
    min: 0,
    max: 0,
  },
}

export default function fuelReportTableColumns({
  chosenCompany,
  handleSetConsolidateInvoice,
}: {
  chosenCompany?: string
  handleSetConsolidateInvoice: (value: string) => void
}) {
  const columnHelper = createColumnHelper<Fuel>()
  return [
    columnHelper.accessor('tyear', {
      id: 'period',
      sortingFn: 'alphanumeric',
      header: 'Periode',
      cell: (row) => (
        <NavLink
          onClick={() => {
            handleSetConsolidateInvoice(row.row.original.consolidatedInvoiceAgreement)
          }}
          className="flex w-fit text-interaction hover:underline hover:text-interactionHover"
          to={`/reports/fuel/${row.row.original.tyear}-${row.row.original.tmonth}`}
        >
          {`${row.row.original.tyear} - ${row.row.original.tmonth}` || ''}
        </NavLink>
      ),
    }),
    columnHelper.accessor('consolidatedInvoiceAgreement', {
      id: 'consolidatedInvoiceAgreement',
      enableSorting: false,
      header: 'Samlefakturakode',
      cell: (row) => getConsolidateInvoiceDescription(row.getValue(), chosenCompany) || '',
    }),
    columnHelper.accessor('amountIncVAT', {
      id: 'amountIncVAT',
      sortingFn: 'alphanumeric',
      meta: {
        mobileFooterLabel: 'Sum av beløp',
        alignmentType: 'right',
      },
      header: 'Beløp',
      cell: (row) => formatCurrency(row.getValue()) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('amountIncVAT') as number) || 0), 0)
        return formatCurrency(total)
      },
    }),
    columnHelper.accessor('volume', {
      id: 'volume',
      sortingFn: 'alphanumeric',
      meta: {
        mobileFooterLabel: 'Totalt mengde',
        alignmentType: 'right',
      },
      header: 'Mengde',
      cell: (row) => formatNumber(row.getValue(), settings) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('volume') as number) || 0), 0)
        return formatNumber(total, settings)
      },
    }),
  ]
}
